/**
 * The expected ("system") figures a shift close records, as pure functions of one store's daily
 * stat — moved verbatim out of `ShiftScreen.js` so they can be tested without the screen, which
 * pulls in UI Kitten and cannot be imported under jest.
 *
 * `systemEndAmounts` holds two kinds of key at once: every payment method's net sales, and the
 * store's cash wallet's drawer balance. The cash method's sales are therefore counted INSIDE the
 * wallet figure — which is why the report folds them into one row (`utils/shiftReportAmounts.js`,
 * ATL-1352 / ATL-1353). This module is the WRITER half of that pair; the regression test walks
 * one shift across both halves, so the two cannot drift apart unnoticed.
 */

/**
 * The store's cash wallet id, AS THE CLOSE RESOLVES IT. Moved verbatim out of `ShiftScreen.js`
 * (`CashboxTransactionScreen.js` kept a byte-identical private copy and now imports this one), and
 * deliberately NOT the same function as `utils/shiftReportAmounts.js`'s reader-side export of the
 * same name: this one
 * indexes `destinationWalletForStore[store]` without `?.`, so a cash method that carries no map at
 * all (the field is optional — `global/Firebase/firestore.types.ts`) throws here and answers
 * `undefined` there. That divergence is ATL-1393 and is not fixed in this behaviour-neutral PR —
 * it lives here so the regression test can pin the WRITER's answer rather than the reader's.
 */
export const getCashWallet = (paymentMethods, store) => {
  if (paymentMethods) {
    for (let pm of paymentMethods) {
      if (pm.id === 'cash') {
        return pm.destinationWalletForStore[store]?.id
      }
    }
  }
}

/** Drawer balance: opening + sales − returns − supplies − spendings − withdrawals + deposits. */
export const cashboxAmount = (dayStat, wallet) => {
  return (dayStat[wallet+'StartAmount'] || 0) + (dayStat[wallet+'SalesAmount'] || 0) - (dayStat[wallet+'ReturnsAmount'] || 0) - (dayStat[wallet+'SuppliesAmount'] || 0) - (dayStat[wallet+'SpendingsAmount'] || 0) - (dayStat[wallet+'WithdrawalsAmount'] || 0) + (dayStat[wallet+'DepositsAmount'] || 0)
}

/** Net sales per payment method, plus the drawer balance under the store's cash wallet id. */
export const computeSystemEndAmounts = (dayStat, paymentMethods, wallet) => {
  var amounts = {}
  paymentMethods.forEach(element => {
    amounts[element.id] = (dayStat[element.id+'SalesAmount'] || 0) - (dayStat[element.id+'ReturnsAmount'] || 0)
  });
  amounts[wallet] = cashboxAmount(dayStat, wallet)
  return amounts
}
